module.exports = __webpack_public_path__ + "img/icon_con_bg.a2943a42.png";